import * as tslib_1 from "tslib";
import { MatPaginatorIntl } from '@angular/material';
var PaginatorI18n = /** @class */ (function (_super) {
    tslib_1.__extends(PaginatorI18n, _super);
    function PaginatorI18n(translate) {
        var _this = _super.call(this) || this;
        _this.translate = translate;
        _this.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return "0 / " + length;
            }
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            var endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
            return startIndex + 1 + " - " + endIndex + " / " + length;
        };
        _this.translate.onLangChange.subscribe(function (e) {
            _this.updateTranslations();
        });
        _this.updateTranslations();
        return _this;
    }
    PaginatorI18n.prototype.updateTranslations = function () {
        var _this = this;
        this.translate.get(['ITEMS_PER_PAGE_LABEL', 'NEXT_PAGE_LABEL', 'PREVIOUS_PAGE_LABEL',
            'FIRST_PAGE_LABEL', 'LAST_PAGE_LABEL']).subscribe(function (translation) {
            _this.itemsPerPageLabel = translation['ITEMS_PER_PAGE_LABEL'];
            _this.nextPageLabel = translation['NEXT_PAGE_LABEL'];
            _this.previousPageLabel = translation['PREVIOUS_PAGE_LABEL'];
            _this.firstPageLabel = translation['FIRST_PAGE_LABEL'];
            _this.lastPageLabel = translation['LAST_PAGE_LABEL'];
            _this.changes.next();
        });
    };
    return PaginatorI18n;
}(MatPaginatorIntl));
export { PaginatorI18n };
